import useConceptRaceGame from './useConceptRaceGame.hook';
import { StyledConceptRaceGame } from './ConceptRaceGame.styled';
import ConceptRaceGameLoop from './GameLoop/ConceptRaceGameLoop';
import ConceptRaceFinalFeedback from './FinalFeedback/ConceptRaceFinalFeedback';
import {
  GameLoopContext,
  GameLoopContextProvider,
} from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { GameAssetsContextProvider } from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';
import { GameStageContextProvider } from '@/shared/GameComponents/GameStageContext/GameStageContext';

export default function ConceptRaceGame({
  gameAssetsFolder,
  commonAssetsFolder,
  activityData,
  onAnswer,
  onFinishedActivity,
  onStart,
  activityConf,
  language,
}) {
  const { state, actions } = useConceptRaceGame({
    gameAssetsFolder,
    commonAssetsFolder,
    activityData,
    onFinishedActivity,
    activityConf,
    language,
  });

  return (
    <StyledConceptRaceGame>
      <GameStageContextProvider scaleAxis={{ landscape: 'y', portrait: 'x' }}>
        <GameAssetsContextProvider
          gameAssetsFolder={gameAssetsFolder}
          gameData={activityData}
          prepareAssets={actions.prepareAssets}
        >
          <GameLoopContextProvider
            fps="30"
            gameConf={activityData}
            prepareGameData={actions.prepareGameData}
            initialState={{
              gameConf: null, // Original data json on db
              currentConcept: null,
              timedOut: false,
              currentAnswerId: null,
              answersLog: [],
              playingOptionAudios: false,
              givingFeedback: false, // for a particular answer
              feedbackFinished: false, // for a particular answer
              concepts: [],
              leftConcepts: [],
              secondChanceConcepts: [], // reinsert concepts in the pool only once if you fail.
            }}
          >
            <GameLoopContext.Consumer>
              {(game) =>
                game.state.isReady &&
                {
                  GAME: (
                    <ConceptRaceGameLoop
                      gameAssetsFolder={gameAssetsFolder}
                      gameData={activityData.gameData}
                      onAnswer={onAnswer}
                      onFinish={actions.onFinish}
                      mode={activityConf.mode}
                    />
                  ),
                  FINALFEEDBACK: <ConceptRaceFinalFeedback />,
                }[state.screen]
              }
            </GameLoopContext.Consumer>
          </GameLoopContextProvider>
        </GameAssetsContextProvider>
      </GameStageContextProvider>
    </StyledConceptRaceGame>
  );
}
